import {
    LegalDocumentView,
} from '@fondationcss/ui';
import AppLayout from '@/app-layout.vue';

export const getCustomRoutes = () => [
    {
      // Formulaire d'admission PUBLIC — page autonome, hors chrome authentifié
      // (pas de DefaultLayout), accessible sans connexion.
      path: '/inscription',
      name: 'public-admission',
      component: () => import('@/views/public/admission-form.vue'),
      meta: { title: "Demande d'admission" }
    },
    {
      // Documents légaux PUBLICS (Loi 25) — pages autonomes rendues par la
      // Fondation à partir des endpoints anonymes /api/Privacy/*.
      path: '/confidentialite',
      name: 'confidentialite',
      component: LegalDocumentView,
      props: { type: 'PrivacyPolicy' },
      meta: { title: 'Politique de confidentialité' }
    },
    {
      path: '/avis-de-collecte',
      name: 'avis-de-collecte',
      component: LegalDocumentView,
      props: { type: 'PrivacyNotice' },
      meta: { title: 'Avis de collecte' }
    },
    {
      path: '/',
      component: AppLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'default-view',
          path: '',
          component: () => import('@/views/default-view.vue')
        },
        {
          name: 'docs',
          path: '/docs/:pathMatch(.*)',
          component: () => import('@/views/documentation.vue'),
          meta: { title: 'Documentation' }
        },
      ]
    },
    {
      path: '/parcours/',
      component: AppLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'parcours-eleve',
          path: 'eleve',
          component: () => import('@/views/parcours/eleve.vue'),
          meta: { title: 'Parcours élève' }
        },
        {
          name: 'parcours-eleve-detail',
          path: 'eleve/:id',
          component: () => import('@/views/parcours/eleve-detail.vue'),
          meta: { title: 'Parcours élève' }
        },
        {
          name: 'parcours-enseignant',
          path: 'enseignant',
          component: () => import('@/views/parcours/enseignant.vue'),
          meta: { title: 'Parcours enseignant' }
        },
        {
          name: 'parcours-planification',
          path: 'planification',
          component: () => import('@/views/parcours/planification.vue'),
          meta: { title: 'Planification' }
        },
        {
          name: 'parcours-gestion',
          path: 'gestion',
          component: () => import('@/views/parcours/gestion.vue'),
          meta: { title: 'Gestion' }
        }
      ]
    },
    {
      path: '/lignedetemps/',
      component: AppLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          // L'élève y voit ses propres cours en cours ; le personnel y ouvre le tableau d'un élève.
          name: 'timeline-dashboard',
          path: 'tableau-de-bord',
          component: () => import('@/views/timeline/dashboard.vue'),
          meta: { title: 'Tableau de bord' }
        },
        {
          name: 'timeline-dashboard-user',
          path: 'tableau-de-bord/:userId',
          component: () => import('@/views/timeline/dashboard.vue'),
          meta: { title: 'Tableau de bord' }
        },
        {
          name: 'timeline-select',
          path: 'visualisateur',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-select-with-user',
          path: 'visualisateur/:userId',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-view',
          path: 'visualisateur/:userId/:timelineId',
          component: () => import('@/views/timeline/view.vue')
        },
        {
          name: 'timeline-settings2',
          path: 'parametres2',
          component: () => import('@/views/timeline/settings2.vue')
        }
      ]
    },
    {
      path: '/admin/',
      component: AppLayout,
      meta: { title: 'Perspective' },
      children: [
        {
          name: 'import-export',
          path: 'import-export',
          component: () => import('@/views/import-export.vue')
        },
        {
          // Espace des rapports PDF. Le bouton « Imprimer en PDF » de l'éditeur de calendrier
          // Fondation y mène avec ?type=calendar&calendarId=…&calendarYearId=… (config
          // CalendarReportRoute dans main.ts).
          name: 'admin-rapports',
          path: 'rapports',
          component: () => import('@/views/rapports.vue'),
          meta: { title: 'Rapports' }
        },
        {
          // Centres (M1b-1): the shared SiteManagement from @byrnu/agora-shared.
          name: 'admin-centres',
          path: 'centres',
          component: () => import('@/views/admin/centres.vue'),
          meta: { title: 'Centres' }
        },
        {
          name: 'admin-systeme-inscription',
          path: 'systeme/inscription',
          component: () => import('@/views/admin/systeme/inscription.vue'),
          meta: { title: 'Demandes d\'admission' }
        },
        {
          name: 'admin-systeme-inscription-config',
          path: 'systeme/inscription-config',
          component: () => import('@/views/admin/systeme/inscription-config.vue'),
          meta: { title: 'Inscription' }
        },
        {
          name: 'admin-systeme-inscription-detail',
          path: 'systeme/inscription/:id',
          component: () => import('@/views/admin/systeme/inscription-detail.vue'),
          meta: { title: "Demande d'admission" }
        },
        {
          name: 'admin-systeme-fga-frequentation',
          path: 'systeme/fga-frequentation',
          component: () => import('@/views/admin/systeme/fga-frequentation.vue'),
          meta: { title: 'Fréquentations FGA' }
        },
        {
          name: 'admin-systeme-fga-frequentation-detail',
          path: 'systeme/fga-frequentation/:id',
          component: () => import('@/views/admin/systeme/fga-frequentation-detail.vue'),
          meta: { title: 'Fréquentation FGA' }
        },
        {
          // Confidentialité (Loi 25) — paramètres de l'organisation, documents
          // légaux et politique de conservation, montés depuis @fondationcss/ui.
          name: 'admin-systeme-privacy',
          path: 'systeme/privacy',
          component: () => import('@/views/admin/systeme/privacy.vue'),
          meta: { title: 'Paramètres de confidentialité' }
        },
        {
          name: 'admin-systeme-privacy-documents',
          path: 'systeme/privacy/documents',
          component: () => import('@/views/admin/systeme/privacy-documents.vue'),
          meta: { title: 'Documents légaux' }
        },
        {
          name: 'admin-systeme-privacy-conservation',
          path: 'systeme/privacy/conservation',
          component: () => import('@/views/admin/systeme/privacy-retention.vue'),
          meta: { title: 'Conservation et suppression' }
        },
        {
          name: 'admin-systeme-audit',
          path: 'systeme/audit',
          component: () => import('@/views/admin/systeme/audit.vue'),
          meta: { title: "Journal d'audit" }
        }
      ]
    }
];
